import React from 'react';
export function WrapperInnerNestedDiv(props) {
    var backgroundUrl = props.backgroundUrl, children = props.children;
    if (!backgroundUrl) {
        return children;
    }
    return React.createElement("div", { style: { lineHeight: '0', fontSize: '0' } }, children);
}
//# sourceMappingURL=wrapper-inner-nested-div.js.map